// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/airspace-class-atc-separation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/airspace-class-atc-separation/airspace-class-atc-separation.js';

mount([g0]);
